import React from 'react';

class WorksComplete extends React.Component {

  render() {
    return (
<div>
    <section className="content-header">
        <h1>
            Works Complete - TODO
        </h1>
    </section>

    <section className="content">

    </section>
</div>
    );
  }
}

export default WorksComplete;
